import React from 'react';
import { ElementsRenderer } from '../shared';
import { TEXT_TYPE } from '../../constants';
import TiptapCodeEditor from '../assignments/AssignmentQuestion/tiptap-editor';
import AiReasonBanner from './AiReasonBanner';

const SubjectiveReview = ({ question, response, answerStatus, answerScoreData }) => {
  const { elements, solution, score: questionScore } = question;
  const { answer } = response;
  const earnedScore = answerScoreData?.score ?? 0;
  const maxScore = answerScoreData?.maxScore ?? questionScore;

  return (
    <div className="katex-question w-full space-y-4 md:space-y-6">
      {answerScoreData && (
        <AiReasonBanner
          reason={answerScoreData.aiReason}
          answerStatus={answerStatus}
          score={earnedScore}
          maxScore={maxScore}
        />
      )}

      <div className="question-container text-base leading-relaxed text-foreground md:text-lg">
        <ElementsRenderer elements={elements} textType={TEXT_TYPE.TIPTAP} />
      </div>

      <div className="space-y-2">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <h4 className="font-medium text-foreground">Your Answer</h4>
          {maxScore != null && (
            <p className="text-sm font-semibold tabular-nums text-foreground">
              Score {earnedScore} / {maxScore}
            </p>
          )}
        </div>
        <TiptapCodeEditor value={answer?.[0]} disabled editorVariant="subjective" />
      </div>

      {solution?.elements?.length > 0 && (
        <div className="space-y-3 border-t border-border/60 pt-4">
          <h4 className="font-medium text-foreground">Detailed Solution</h4>
          <div className="text-sm leading-relaxed text-muted-foreground">
            <ElementsRenderer elements={solution.elements} textType={TEXT_TYPE.TIPTAP} />
          </div>
        </div>
      )}
    </div>
  );
};

export default SubjectiveReview;
